import { Controller } from '@hotwired/stimulus';

// Panneau replié sur téléphone (classe max-sm:hidden), toujours visible sur
// ordinateur : le bouton l'ouvre ou le ferme (aria-expanded).
export default class extends Controller {
    static targets = ['button', 'panel'];

    toggle() {
        const open = !this.panelTarget.classList.toggle('max-sm:hidden');
        this.buttonTarget.setAttribute('aria-expanded', String(open));
    }
}
